import { CSSProperties, SVGProps } from 'react'
import Colors from 'modules/Colors'

interface AmazonFlatIconProps extends SVGProps<SVGSVGElement> {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const AmazonFlatIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 40,
    onClick
}: AmazonFlatIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            onClick={onClick}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_453_69)">
                <path
                    d="M31.5481 29.8352C18.5945 36 10.5554 30.8421 5.40932 27.7093C5.09088 27.5119 4.54965 27.7554 5.01924 28.2948C6.73366 30.3736 12.3522 35.3841 19.686 35.3841C27.0248 35.3841 31.3908 31.3796 31.9369 30.6811C32.4794 29.9885 32.0962 29.6064 31.5479 29.8352H31.5481ZM35.186 27.8261C34.8382 27.3731 33.0708 27.2887 31.9586 27.4253C30.8446 27.558 29.1725 28.2388 29.3179 28.6476C29.3925 28.8007 29.5448 28.7321 30.31 28.6632C31.0774 28.5867 33.227 28.3154 33.675 28.9009C34.125 29.4905 32.9893 32.2993 32.7819 32.7522C32.5815 33.2052 32.8585 33.322 33.2349 33.0203C33.6062 32.7187 34.2782 31.9377 34.7292 30.8325C35.1772 29.7212 35.4504 28.171 35.186 27.8261Z"
                    fill={color}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22.8382 17.256C22.8382 18.8735 22.8791 20.2225 22.0615 21.659C21.4016 22.827 20.3563 23.5452 19.1884 23.5452C17.5941 23.5452 16.6656 22.3306 16.6656 20.5378C16.6656 16.999 19.8365 16.3567 22.8382 16.3567V17.256ZM27.0252 27.3761C26.7507 27.6213 26.3536 27.6389 26.0441 27.4753C24.666 26.3308 24.4207 25.7994 23.6616 24.7073C21.3841 27.0315 19.7724 27.7264 16.8175 27.7264C13.3254 27.7264 10.6041 25.5716 10.6041 21.2561C10.6041 17.8867 12.432 15.5917 15.0305 14.4705C17.2847 13.4777 20.4323 13.3025 22.8382 13.0282V12.4909C22.8382 11.5039 22.914 10.336 22.336 9.48348C21.8279 8.71847 20.8585 8.40311 20.0059 8.40311C18.4234 8.40311 17.0102 9.21478 16.6656 10.8966C16.5955 11.2704 16.3211 11.6383 15.9474 11.6558L11.918 11.2238C11.5794 11.1477 11.2057 10.8733 11.2991 10.3535C12.2276 5.47168 16.6364 4 20.5839 4C22.6044 4 25.2439 4.53729 26.8382 6.06732C28.8587 7.95346 28.666 10.4703 28.666 13.2091V19.6794C28.666 21.624 29.4719 22.4765 30.231 23.5277C30.4995 23.9014 30.558 24.3512 30.2193 24.6314C29.3725 25.3379 27.8659 26.6519 27.0367 27.3878L27.025 27.3761"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_453_69">
                    <rect width="32" height="32" fill="white" transform="translate(4 4)"/>
                </clipPath>
            </defs>
        </svg>
    )
}

export default AmazonFlatIcon
